import { Typography } from '@mui/material';
import styled from 'styled-components';

const PaperContainer = styled.div`
  && {
    width: 100%;
    /* max-width: 512px; */
    display: flex;
    align-items: center;
    justify-content: flex-start;
    /* padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(4)}`}; */
    flex-direction: row;
    position: relative;
  }
`;

const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  margin-left: ${({ theme }) => theme.spacing(4)};
`;

const Name = styled(Typography)`
`;

const Description = styled(Typography)`
`;

export { Name,
  Description,
  PaperContainer,
  NameContainer };
